"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _api = require("@focaltec-suite/api");
var _commons = require("@focaltec-suite/commons");
var _core = require("@focaltec-suite/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function UserAssistantPopup(_ref) {
  var user = _ref.user,
    tenantId = _ref.tenantId,
    access = _ref.access,
    onCompleted = _ref.onCompleted,
    onError = _ref.onError,
    onCancelled = _ref.onCancelled;
  var context = (0, _react.useContext)(_core.AppContext);
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    submitting = _useState2[0],
    setSubmitting = _useState2[1];
  var _useValidatedForm = (0, _commons.useValidatedForm)(),
    bind = _useValidatedForm.bind,
    register = _useValidatedForm.register,
    isValid = _useValidatedForm.isValid;
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    apps = _useState4[0],
    setApps = _useState4[1];
  var retrievePromise = (0, _react.useCallback)(function () {
    return (0, _api.getTenant)(tenantId, {
      includeApps: true
    }, {
      access: access
    });
  }, [tenantId, access]);
  var setData = (0, _react.useCallback)(function (tenant) {
    var _a, _b;
    setApps((_b = (_a = tenant.apps) === null || _a === void 0 ? void 0 : _a.map(function (el) {
      return {
        value: el.id,
        label: el.name
      };
    })) !== null && _b !== void 0 ? _b : []);
  }, []);
  var assistPromise = (0, _react.useCallback)(function (request) {
    return (0, _api.createPlatformAssistant)(tenantId, user.id, request, {
      access: access
    });
  }, [tenantId, access, user]);
  var onConfirm = function onConfirm() {
    if (!isValid()) return;
    setSubmitting(true);
    var request = bind();
    assistPromise(request).then(function (assistant) {
      setSubmitting(false);
      var host;
      switch (request.app_id) {
        case 'cdg':
          host = process.env.REACT_APP_CDG_URL;
          break;
        default:
          host = '';
      }
      onCompleted(assistant, "".concat(host, "/t/").concat(tenantId));
    })["catch"](function (error) {
      setSubmitting(false);
      onError(error.message);
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    variant: "primary",
    title: (0, _core.translate)('assistants.support.title', {
      name: user.name
    }),
    disableEscapeKeyDown: submitting,
    disableBackdropClick: submitting,
    disable: submitting,
    onClose: onCancelled,
    button: {
      text: (0, _core.translate)('buttons.signin'),
      onClick: onConfirm,
      disabled: submitting
    },
    fullWidth: true,
    maxWidth: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_commons.Retrievable, {
    getPromise: retrievePromise,
    setData: setData,
    builder: function builder() {
      return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12,
        sx: context.appId === 'admin' ? undefined : {
          display: 'none'
        }
      }, /*#__PURE__*/_react["default"].createElement(_commons.AnyAutocomplete, {
        name: "app_id",
        label: (0, _core.translate)('apps.single'),
        options: apps,
        initialValue: context.appId,
        register: register,
        required: true,
        disabled: context.appId !== 'admin'
      })), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
        type: "password",
        name: "password",
        label: (0, _core.translate)('assistants.support.password'),
        register: register,
        required: true
      }), /*#__PURE__*/_react["default"].createElement(_commons.AnyInput, {
        type: "text",
        name: "reason",
        label: (0, _core.translate)('assistants.support.reason'),
        register: register,
        required: true,
        rows: 3
      })));
    }
  }));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(UserAssistantPopup);